"use client";

import { type FC, useRef } from "react";
import { useTranslation } from "react-i18next";
import {
  Badge,
  IconButton,
  Tooltip,
  getTotalSubStepsLeftFromStep,
  useKeys,
} from "@huub-web/ui";
import { useNavigationState } from "../../providers";

type FixedCompactNavigationHeaderButtonProps = {
  disabled?: boolean;
};

/**
 * A fixed navigation component for mobile devices.
 */
export const FixedCompactNavigationHeaderButton: FC<
  FixedCompactNavigationHeaderButtonProps
> = ({ disabled = false }) => {
  const { t } = useTranslation();
  const { activeNavigationRecord, isMenuOpen, toggleMenu, setMenuOpen } =
    useNavigationState();

  useKeys(["Escape"], () => {
    setMenuOpen(false);
  });

  const buttonRef = useRef<HTMLButtonElement>(null);

  const stepsLeft = activeNavigationRecord
    ? getTotalSubStepsLeftFromStep(activeNavigationRecord)
    : undefined;

  // const progress = useMemo(
  //   () =>
  //     activeNavigationRecord
  //       ? getTotalProgressFromStep(activeNavigationRecord)
  //       : undefined,
  //   [activeNavigationRecord],
  // );

  return (
    <Tooltip value={t("menu.open")} placement="right">
      <IconButton
        ref={buttonRef}
        disabled={disabled}
        icon={activeNavigationRecord?.icon ?? "compass"}
        onClick={toggleMenu}
        variant={isMenuOpen ? "opaque" : "tertiary"}
        rounded
        size="header"
      >
        {/* <AnimatePresence>
          {!isMenuOpen &&
            progress !== undefined &&
            progress !== null &&
            progress !== 0 && (
              <CircularProgress progress={progress} variant="opaque" absolute />
            )}
        </AnimatePresence> */}

        {!!stepsLeft && stepsLeft > 0 && (
          <Badge value={stepsLeft} offset="small" variant="accent" />
        )}
      </IconButton>
    </Tooltip>
  );
};
